module.exports = __webpack_public_path__ + "img/fuwuxiangmu_jpg5_fwsxq.5177f13e.png";